export default __webpack_public_path__ + "static/style3.6_Grandma-ba2b3e507e7c1ba27bc05c52717413e3.wav";